// extracted by mini-css-extract-plugin
module.exports = {"notfound":"_404-module--notfound--2DPGu","Layout":"_404-module--Layout--2zljd","Header":"_404-module--Header--2afDJ","Link":"_404-module--Link--1iwPr"};